import {
  Box,
  Flex,
  Icon,
  Input,
  Select,
  Skeleton,
  Stack,
  Text,
  useTheme,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import RideCard from "../../components/RideCard";
import Nodata from "../../components/Nodata";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import Cookies from "js-cookie";

const RideHistoryLifeTime = () => {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [historyLifetime, setHistoryLifetime] = React.useState<any>();
  const [isDataFetching, setIsDataFetching] = React.useState(true);

  const [pageNumber, setPageNumber] = React.useState(() => {
    return Number(localStorage.getItem("historypage")) || 1;
  });

  const [totalPages, setTotalPages] = React.useState<number>();
  const [total, setTotal] = React.useState<number>();
  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);

  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [status, setStatus] = React.useState("");

  const formatToISO8601 = (dateString: string) => {
    if (!dateString) return "";

    return new Date(`${dateString}T00:00:00`).toISOString();
  };
  const buildHistoryUrl = () => {
    let url = `/rides/all?page=${pageNumber}`;

    if (status && status !== "all") {
      url += `&status=${status}`;
    }

    // Start and end date must work together
    if (startDate && endDate) {
      url += `&start_date=${formatToISO8601(startDate)}`;
      url += `&end_date=${formatToISO8601(endDate)}`;
    }

    return url;
  };

  const getHistoryLifetime = async () => {
    setIsDataFetching(true);

    try {
      const res = await axios.get(buildHistoryUrl(), {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

      console.log("history", res.data);

      setHistoryLifetime(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setTotal(res.data.pagination.total);

      setNextNotAllowed(res.data.data.length < 20);
    } catch (error) {
      console.log("error ride history", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  React.useEffect(() => {
    getHistoryLifetime();
  }, [pageNumber, status, startDate, endDate]);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Flex
        sx={{
          margin: "2.5rem 0 2rem 2rem",
          gap: "1rem",
          alignItems: "baseline",
        }}
      >
        <Text
          sx={{
            fontSize: theme.fontSizes.subHeading1,
          }}
        >
          Daily Ride Activities and History
        </Text>
        <Flex sx={{ flex: 1, justifyContent: "flex-end" }}>
          <Text
            sx={{
              fontSize: theme.fontSizes.body,
              marginRight: "0.25rem",
            }}
          >
            Total:
          </Text>
          <Skeleton isLoaded={!isDataFetching}>
            <Text
              sx={{
                fontSize: theme.fontSizes.body,
                color: "green",
              }}
            >
              {total}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>

      <Box
        sx={{
          paddingX: "2rem",
        }}
      >
        <Box
          sx={{
            maxWidth: "30.5rem",
          }}
        >
          <Stack direction={{ base: "column", md: "row" }} spacing={4} mb={6}>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />

            <Select
              placeholder="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="all">All</option>
              <option value="finished">Completed</option>
              <option value="canceled">Canceled</option>
              <option value="onprogress">On Progress</option>
              <option value="requested">Requested</option>
              <option value="pending">Pending</option>
            </Select>
          </Stack>
        </Box>

        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {historyLifetime && historyLifetime.length !== 0 ? (
            historyLifetime?.map((item: any, index: number) => {
              return <RideCard key={index} item={item} />;
            })
          ) : (
            <Box
              style={{
                padding: "2rem",
              }}
            >
              <Nodata heading="No History Listed" />
            </Box>
          )}
        </Skeleton>
      </Box>

      <Box
        sx={{
          marginTop: theme.space.xl,
        }}
      >
        <Flex
          sx={{
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "3rem",
          }}
        >
          <Box>
            <Flex
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <Flex
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  width: "2rem",
                  height: "2rem",
                }}
              >
                <Icon
                  as={MdArrowBackIosNew}
                  boxSize={5}
                  color={theme.colors.primary.main}
                  cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                  onClick={() => {
                    if (pageNumber !== 1) {
                      setPageNumber(pageNumber - 1);
                      localStorage.setItem("historypage", `${pageNumber - 1}`);
                      // setRefetchUrl(`/riders?page=${pageNumber - 1}`);
                    }
                  }}
                />
              </Flex>
              <Text variant={"caption"}>Previous Page</Text>
            </Flex>
          </Box>
          <Skeleton
            isLoaded={isDataFetching ? false : true}
            sx={{ width: "2rem" }}
          >
            <Text variant={"body"}>{pageNumber}</Text>
          </Skeleton>
          <Box>
            <Flex
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              <Text variant={"caption"}>Next Page</Text>
              <Flex
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  width: "2rem",
                  height: "2rem",
                }}
              >
                <Icon
                  as={MdArrowForwardIos}
                  boxSize={5}
                  color={theme.colors.primary.main}
                  cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                  onClick={() => {
                    if (!nextNotAllowed) {
                      setPageNumber(pageNumber + 1);
                      localStorage.setItem("historypage", `${pageNumber + 1}`);
                      // setRefetchUrl(`/riders?page=${pageNumber + 1}`);
                    }
                  }}
                />
              </Flex>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default RideHistoryLifeTime;
